import moment, {
    unitOfTime,
} from 'moment';

export const diff = (dob: any, measure: unitOfTime.Diff = 'years', round: boolean = false) => {
    let age;
    if (dob !== undefined && dob !== null && dob !== "") {
        age = moment().diff(dob, measure, round);
    }
    return age;
}